<template>
  <div class="activity-list">
    <h1 class="title">活动中心</h1>
    <table>
      <thead>
        <tr>
          <th>活动 ID</th>
          <th>活动名称</th>
          <th>活动描述</th>
          <th>开始时间</th>
          <th>结束时间</th>
          <th>策略 ID</th>
          <th>活动状态</th>
          <th>库存</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(activity, index) in activities" :key="index">
          <td>{{ activity.id }}</td>
          <td>{{ activity.name }}</td>
          <td>{{ activity.description }}</td>
          <td>{{ activity.startDate }}</td>
          <td>{{ activity.endDate }}</td>
          <td>{{ activity.strategyId }}</td>
          <td>{{ activity.status }}</td>
          <td>{{ activity.stock }}</td>
          <td>
            <el-button type="text" @click="open">
                <i class="el-icon-edit"></i>
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Activity",
  data() {
    return {
      activities: [
        {
          id: 1,
          name: "夏季促销",
          description: "夏季促销活动",
          startDate: "2024-03-01",
          endDate: "2024-05-31",
          strategyId: 1001,
          status: "进行中",
          stock: 500,
        },
        {
          id: 2,
          name: "会员日优惠",
          description: "会员日专享优惠",
          startDate: "2024-03-01",
          endDate: "2024-05-05",
          strategyId: 1002,
          status: "即将开始",
          stock: 1000,
        },
        {
          id: 3,
          name: "新品发布",
          description: "秋季新品发布会",
          startDate: "2024-03-10",
          endDate: "2024-05-15",
          strategyId: 1003,
          status: "已结束",
          stock: 0,
        },
        {
          id: 3,
          name: "未知活动",
          description: "未知活动",
          startDate: "2024-03-10",
          endDate: "2024-05-15",
          strategyId: 1003,
          status: "已结束",
          stock: 0,
        },
        {
          id: 4,
          name: "未知活动",
          description: "未知活动",
          startDate: "2024-03-10",
          endDate: "2024-05-15",
          strategyId: 1003,
          status: "已结束",
          stock: 0,
        },
        {
          id: 5,
          name: "未知活动",
          description: "未知活动",
          startDate: "2024-03-10",
          endDate: "2024-05-15",
          strategyId: 1001,
          status: "已结束",
          stock: 0,
        },
        {
          id: 6,
          name: "未知活动",
          description: "未知活动",
          startDate: "2024-03-10",
          endDate: "2024-05-15",
          strategyId: 1001,
          status: "已结束",
          stock: 0,
        },
      ],
    };
  },
  methods: {
    open() {
        this.$alert('开发中 ...', '编辑', {
          confirmButtonText: '确定',
          callback: () => {
            this.$message({
              type: 'info',
              message: '开发中'
            });
          }
        });
      }
  }
};
</script>

<style scoped>
.activity-list {
  max-width: 50vx;
  margin: left;
}

.title {
  text-align: center;   
  color: #c0dcfb;
  font-size: 2em;
  margin-bottom: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}

tr:hover {
  background-color: #f5f5f5;
}
</style>